/* eslint-disable react/no-array-index-key */
import { Box, Typography, Divider, IconButton, Chip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import useReplacementValues from "../hooks/use-replacement-values";
import { useReplacementValuesManagement } from "../hooks/use-replacement-values-management";
import ReplacementValuesTable from "./replacement-values-table";
import ReplacementValueFormDialog from "./replacement-value-form-dialog";
import ReplacementValueDeleteDialog from "./replacement-value-delete-dialog";

interface TemplateReplacementValuesProps {
  templateId: number | null;
}

const TemplateReplacementValues = ({
  templateId,
}: TemplateReplacementValuesProps) => {
  const { replacementValues, isLoading, mutate } =
    useReplacementValues(templateId);

  const {
    openDialog,
    formValues,
    editIndex,
    isSaving,
    setFormValues,
    handleOpenDialog,
    handleOpenEditDialog,
    handleCloseDialog,
    handleSave,
    deleteConfirmOpen,
    valueToDelete,
    isDeleting,
    handleDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useReplacementValuesManagement({
    templateId: templateId ?? 0,
    mutate,
  });

  const valueCount = replacementValues?.length ?? 0;

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 3,
            mb: 0.5,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Typography variant="body2" fontWeight={600}>
              Replacement Values
            </Typography>
            <Chip
              label={`${valueCount} active`}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ height: 20, fontSize: "0.7rem" }}
            />
          </Box>
          <IconButton
            size="small"
            color="success"
            onClick={handleOpenDialog}
            disabled={isLoading || !templateId}
            aria-label="Add value"
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 1 }} />

        <Box
          sx={{
            border: 1,
            borderColor: "grey.300",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <ReplacementValuesTable
            replacementValues={replacementValues ?? []}
            onEdit={handleOpenEditDialog}
            onDelete={handleDelete}
            isLoading={isLoading}
          />
        </Box>
      </Box>

      <ReplacementValueFormDialog
        open={openDialog}
        formValues={formValues}
        editIndex={editIndex}
        isSaving={isSaving}
        onClose={handleCloseDialog}
        onSave={handleSave}
        onChange={setFormValues}
      />

      <ReplacementValueDeleteDialog
        open={deleteConfirmOpen}
        value={valueToDelete}
        isDeleting={isDeleting}
        onCancel={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default TemplateReplacementValues;
